import React, { useState } from 'react';
import { createPayment } from '../services/api';
import Button from '../components/Button';
import Modal from '../components/Modal';
import './Payments.css';

const Payments = () => {
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState('');
  const [paymentSent, setPaymentSent] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!paymentSent) {
      setMessage('Please confirm that you have sent the payment.');
      return;
    }
    try {
      await createPayment({ amount: parseFloat(amount) });
      setMessage('Payment recorded successfully!');
      setAmount('');
      setPaymentSent(false);
      setShowModal(false);
    } catch (error) {
      setMessage('Failed to record payment.');
      console.error('Payment recording failed', error);
    }
  };

  return (
    <div className="payments-container">
      {showModal && (
        <Modal onClose={() => setShowModal(false)}>
          <h2>Make a Payment</h2>
          <p>Please use the following details for your international wire transfer:</p>
          <ul>
            <li><strong>Bank:</strong> PNC Bank</li>
            <li><strong>Account Number:</strong> 5548892182</li>
            <li><strong>Domestic Routing Number:</strong> 054000096</li>
            <li><strong>Swift Code:</strong> PNCCUS33XXX</li>
            <li><strong>Account Name:</strong> Zentara, INC</li>
            <li><strong>Address:</strong> 303 Smith Level Road, A14, Chapel Hill, NC 27516</li>
            <li><strong>Currency:</strong> USD</li>
          </ul>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>
                <input type="checkbox" checked={paymentSent} onChange={(e) => setPaymentSent(e.target.checked)} />
                Payment sent successfully
              </label>
            </div>
            <div className="form-group">
              <label>Amount</label>
              <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} />
            </div>
            <Button type="submit">Submit</Button>
          </form>
          {message && <p>{message}</p>}
        </Modal>
      )}
      <h1>Payments</h1>
      <p>Make your weekly payment to EarnGain here every Friday.</p>
      <Button onClick={() => setShowModal(true)}>Make a Payment</Button>
      {message && <p>{message}</p>}
    </div>
  );
};

export default Payments;
